import { Link } from "react-router-dom";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="v21-logo group" aria-label="回到学习库">
      <span className="logo-mark" aria-hidden="true">
        <span>T</span>
        <i />
      </span>
      {!compact && (
        <span className="v21-logo-copy">
          <strong>双语精听</strong>
          <small>TED LISTENING ROOM</small>
        </span>
      )}
    </Link>
  );
}

